<template>
  <div>
    <component
      :is="mode"
      :data="payload"
      @goToReport="goToReport($event)"
    ></component>
  </div>
</template>

<script>
import ListComponent from '../components/reports/List';
import MenuComponent from '../components/reports/Menu';
import { mapGetters } from 'vuex';

export default {
  name: 'report',
  components: {
    'list-component': ListComponent,
    'menu-component': MenuComponent
  },
  data: () => ({
    mode: 'menu-component',
    payload: {}
  }),
  computed: {
    ...mapGetters(['reportList'])
  },
  mounted() {
    this.showMenu();
  },
  methods: {
    // Вывод конкретного раздела по его тегу
    goToReport(tag) {
      this.payload = tag;
      this.mode = 'list-component';
    },
    // Вывод списка всех разделов
    showMenu() {
      this.payload = this.reportList;
      this.mode = 'menu-component';
    }
  }
};
</script>

<style></style>
